import { Component, OnInit } from '@angular/core';
import { LitigationEventsService } from './litigation-events.service';

@Component({
  selector: 'app-litigation-events',
  standalone: false,
  templateUrl: './litigation-events.component.html',
  styleUrl: './litigation-events.component.scss'
})
export class LitigationEventsComponent implements OnInit {
  litigationEvents: any[] = [];
  loading: boolean = true;
  allLitigationEvents: any[] = [];
  fromEventDate: string | null = null;   // yyyy-MM-dd
  toEventDate: string | null = null;     // yyyy-MM-dd

  selectedEventCategory: string = 'Litigation Events';
  eventCategoryOptions: any[] = [
    { label: 'Litigation Events', value: 'Litigation Events' },
    { label: 'Appeal Events', value: 'Appeal Events' }
  ];

  globalFilterFields: string[] = [
    'caseNumber',
    'nda',
    'brand',
    'plaintiff',
    'defendant',
    'filedAnda',
    'courtName',
    'filedDate',
    'eventName',
    'eventDate'
  ];

  constructor(
    private litigationEventsService: LitigationEventsService
  ) { }

  ngOnInit(): void {
    this.fetchData();
  }

  onEventCategoryChange(event?: any): void {
    this.fromEventDate = null;
    this.toEventDate = null;
    this.fetchData();
  }

  fetchData(): void {
    if (this.selectedEventCategory === 'Litigation Events') {
      this.globalFilterFields = [
        'caseNumber',
        'nda',
        'brand',
        'plaintiff',
        'defendant',
        'filedAnda',
        'courtName',
        'filedDate',
        'eventName',
        'eventDate'
      ];
      this.loadLitigationEvents();
    } else if (this.selectedEventCategory === 'Appeal Events') {
      this.globalFilterFields = [
        'caseNumber',
        'appealCaseNumber',
        'nda',
        'brand',
        'plaintiff',
        'defendant',
        'courtName',
        'appealCourt',
        'appellant',
        'appealStatus',
        'eventName',
        'eventDate'
      ];
      this.loadAppealEvents();
    } else {
      this.allLitigationEvents = [];
      this.litigationEvents = [];
      this.loading = false;
    }
  }

  loadLitigationEvents(): void {
    this.loading = true;
    this.litigationEventsService.getAllLitigationEvents().subscribe({
      next: (response) => {
        if (response && response.data) {
          const mapped = response.data.map((item: any) => {
            return {
              litigationCategory: item['Litigation Category'],
              caseNumber: item['Case Number'],
              nda: item['NDA'],
              brand: item['Brand'],
              plaintiff: item['Plaintiff'],
              defendant: item['Defendant'],
              filedAnda: Array.isArray(item['Filed ANDA'])
                ? item['Filed ANDA'].join(' | ')
                : item['Filed ANDA'],
              courtName: item['Court Name'],
              filedDate: item['Filed Date'],
              eventName: item['Event Name'],
              eventDate: item['Event Date']
            };
          });

          this.allLitigationEvents = mapped;
          this.litigationEvents = [...mapped];
        } else {
          this.allLitigationEvents = [];
          this.litigationEvents = [];
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading litigation events', err);
        this.allLitigationEvents = [];
        this.litigationEvents = [];
        this.loading = false;
      }
    });
  }

  loadAppealEvents(): void {
    this.loading = true;
    this.litigationEventsService.getAllAppealEvents().subscribe({
      next: (response) => {
        if (response && response.data) {
          const mapped = response.data.map((item: any) => {
            return {
              litigationCategory: item['Litigation Category'],
              caseNumber: item['Case Number'],
              appealCaseNumber: item['Appeal Case Number'],
              nda: item['NDA'],
              brand: item['Brand'],
              plaintiff: item['Plaintiff'],
              defendant: item['Defendant'],
              courtName: item['Court Name'],
              appealCourt: item['Appeal Court'],
              appellant: item['Appellant'],
              appealStatus: item['Appeal Status'],
              eventName: item['Event Name'],
              eventDate: item['Event Date']
            };
          });

          this.allLitigationEvents = mapped;
          this.litigationEvents = [...mapped];
        } else {
          this.allLitigationEvents = [];
          this.litigationEvents = [];
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading appeal events', err);
        this.allLitigationEvents = [];
        this.litigationEvents = [];
        this.loading = false;
      }
    });
  }

  onApplyEventDateFilter(): void {
    if (!this.fromEventDate && !this.toEventDate) {
      this.litigationEvents = [...this.allLitigationEvents];
      return;
    }

    const from = this.fromEventDate ? new Date(this.fromEventDate) : null;
    const to = this.toEventDate ? new Date(this.toEventDate) : null;

    if (from) {
      from.setHours(0, 0, 0, 0);
    }
    if (to) {
      to.setHours(0, 0, 0, 0);
    }

    this.litigationEvents = this.allLitigationEvents.filter(row => {
      if (!row.eventDate) {
        return false;
      }

      const cellDate = new Date(row.eventDate);
      if (isNaN(cellDate.getTime())) {
        return false;
      }

      cellDate.setHours(0, 0, 0, 0);

      if (from && cellDate < from) {
        return false;
      }
      if (to && cellDate > to) {
        return false;
      }

      return true;
    });
  }

  onClearEventDateFilter(): void {
    this.fromEventDate = null;
    this.toEventDate = null;
    this.litigationEvents = [...this.allLitigationEvents];
  }
}